import { UseQueryOptions, useSuspenseQuery } from "@tanstack/react-query";
import axiosInstance from "@/lib/axios";
import {
  KycNextLevelRequirements,
  KycNextLevelRequirementsSchema,
} from "@/schemas/kyc";

interface UserKYCParams {
  user?: string;
}

interface UseKYCOptions
  extends Omit<
    UseQueryOptions<
      KycNextLevelRequirements,
      Error,
      KycNextLevelRequirements,
      ["user", "kyc"]
    >,
    "queryKey" | "queryFn"
  > {
  queryParams: UserKYCParams;
}

export function useKYCNextStepRequirements(options: UseKYCOptions) {
  const { queryParams } = options;

  return useSuspenseQuery({
    queryKey: ["user", "Kyc-next-level", queryParams.user],
    queryFn: async () => {
      const response = await axiosInstance.get(`/wallet/kyc/user/nextopt`, {
        params: queryParams,
        baseURL: "/api/proxy",
      });
      return KycNextLevelRequirementsSchema.parse(response.data.data);
    },
  });
}
